import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-shop-select-dialog',
  templateUrl: './shop-select-dialog.component.html',
  styleUrls: ['./shop-select-dialog.component.scss'],
  standalone: false
})
export class ShopSelectDialogComponent implements OnInit {
  shops: any[] = [];
  selectedIds: number[] = [];
  searchQuery: string = '';

  constructor(
    public dialogRef: MatDialogRef<ShopSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.shops = data.shops || [];
    
    // Only select the last selected shop!
    const passedSelectedIds = data.selectedIds || [];
    if (passedSelectedIds.length > 0) {
      this.selectedIds = [Number(passedSelectedIds[passedSelectedIds.length - 1])];
    } else if (this.shops.length > 0) {
      this.selectedIds = [Number(this.shops[0].id)];
    } else {
      this.selectedIds = [];
    }
  }

  ngOnInit(): void {}

  get filteredShops() {
    if (!this.searchQuery) return this.shops;
    const q = this.searchQuery.toLowerCase();
    return this.shops.filter(s => 
      s.name.toLowerCase().includes(q) || 
      (s.code && s.code.toLowerCase().includes(q))
    );
  }

  toggleSelection(shopId: number) {
    this.selectedIds = [Number(shopId)];
  }

  isSelected(shopId: number): boolean {
    return this.selectedIds.includes(Number(shopId));
  }

  getSelectedShopName(): string {
    if (this.selectedIds.length === 0) return '';
    const selectedShop = this.shops.find(s => Number(s.id) === Number(this.selectedIds[0]));
    return selectedShop ? (selectedShop.name + (selectedShop.code ? ` (${selectedShop.code})` : '')) : '';
  }

  toggleAll() {
    if (this.selectedIds.length === this.shops.length) {
      this.selectedIds = [];
    } else {
      this.selectedIds = this.shops.map(s => s.id);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close(this.selectedIds);
  }
}
